"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteSubscription = exports.defineChildren = exports["default"] = exports.completeFlow = exports.completeFilePreload = exports.addSubscription = exports.addAjax = void 0;
exports.getMetricsData = getMetricsData;
exports.getProgressData = getProgressData;
exports.waitForResultSaved = exports.updateSettings = exports.updateSavedProgress = exports.updateSavedAnswers = exports.updatePageFirstElement = exports.updateFilePreloadProgress = exports.updateAnswers = exports.updateAnswer = exports.unsetPlayingAction = exports.unsetLoadingState = exports.switchFeedbackMode = exports.startFilePreloadProgress = exports.showCompleteMessage = exports.showBadConnectionMessage = exports.setWaitingForAjax = exports.setValidationErrors = exports.setToStorage = exports.setStartedProgress = exports.setResponseSet = exports.setPreviewList = exports.setPreloadingAssetsProgress = exports.setPlayingParentId = exports.setPlayingAction = exports.setPawnId = exports.setPawnHash = exports.setParameters = exports.setPageStartedTime = exports.setMetricsValues = exports.setLoadingState = exports.setList = exports.setIsPresenterMode = exports.setFlowId = exports.setFinishedProgress = exports.setEnableAudio = exports.setDynamicUserListsValues = exports.setDynamicDataValues = exports.setAudioReady = exports.setAnswerError = exports.setAccommodations = exports.saveStateAndMetrics = exports.saveResult = exports.saveMetricsOnUnload = exports.saveAndGoToPrevPage = exports.saveAndGoToNextPage = exports.saveAndGoToComponent = exports.resetAnswers = exports.resetAll = exports.resetActions = exports.removeAjax = exports.registerAction = exports.preloadAndGoToNextPage = exports.loadFlow = exports.initialState = exports.goToPrevPage = exports.goToNextPage = void 0;
var _reduxActions = require("redux-actions");
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _dropWhile2 = _interopRequireDefault(require("lodash/dropWhile"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _builder = require("./builder.js");
var _player = require("../selectors/player.js");
var _allElements = _interopRequireDefault(require("../allElements.js"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _helpers = require("../other/helpers.js");
var _cccisdPreload = _interopRequireDefault(require("cccisd-preload"));
var _config = _interopRequireDefault(require("../config.js"));
var _browser = require("@sentry/browser");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var allElementsObject = _allElements["default"].reduce(function (obj, element) {
  obj[element.code] = element;
  return obj;
}, {});
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var ajaxCount = 0;
var noNetworkRequst = 'No Network Request';

// Initial state
var initialState = {
  isCompleted: false,
  isCompleteMessage: false,
  loading: false,
  waitingForAjax: false,
  list: {},
  rootId: 0,
  settings: {},
  answers: {},
  savedAnswers: {},
  progress: {},
  savedProgress: {},
  errors: {},
  showValidationErrors: false,
  pageFirstElementId: 0,
  pageHistory: [],
  actions: [],
  playingAction: [],
  playingParentId: 0,
  parameters: {},
  accommodations: {},
  flowId: 0,
  pawnId: 0,
  pawnHash: '',
  responseSet: 0,
  pageStartedTime: 0,
  storage: {},
  subscriptions: {},
  isAudioReady: true,
  enableAudio: true,
  ajax: [],
  hasBadConnection: false,
  badConnectionInfo: {},
  elementsNumberToPreloadAssets: 10,
  preloadedAssets: [],
  preloadingAssetsProgress: 100,
  dynamicDataValues: {},
  dynamicUserListsValues: {},
  metricsValues: {},
  isFeedbackMode: false,
  isPresenterMode: false,
  allElements: _allElements["default"],
  config: _config["default"]
};

// Actions
exports.initialState = initialState;
var SET_LOADING_STATE = 'flow/player/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'flow/player/UNSET_LOADING_STATE';
var SET_WAITING_FOR_AJAX = 'flow/player/SET_WAITING_FOR_AJAX';
var RESET_ALL = 'flow/player/RESET_ALL';
var UPDATE_SETTINGS = 'flow/player/UPDATE_SETTINGS';
var SET_LIST = 'flow/player/SET_LIST';
var UPDATE_ANSWER = 'flow/player/UPDATE_ANSWER';
var UPDATE_ANSWERS = 'flow/player/UPDATE_ANSWERS';
var SET_ANSWER_ERROR = 'flow/player/SET_ANSWER_ERROR';
var UPDATE_SAVED_ANSWERS = 'flow/player/UPDATE_SAVED_ANSWERS';
var UPDATE_SAVED_PROGRESS = 'flow/player/UPDATE_SAVED_PROGRESS';
var RESET_ANSWERS = 'flow/player/RESET_ANSWERS';
var UPDATE_PAGE_FIRST_ELEMENT = 'flow/player/UPDATE_PAGE_FIRST_ELEMENT';
var SET_VALIDATION_ERRORS = 'flow/player/SET_VALIDATION_ERRORS';
var GO_TO_NEXT_PAGE = 'flow/player/GO_TO_NEXT_PAGE';
var GO_TO_PREV_PAGE = 'flow/player/GO_TO_PREV_PAGE';
var RESET_ACTIONS = 'flow/player/RESET_ACTIONS';
var COMPLETE_FLOW = 'flow/player/COMPLETE_FLOW';
var SHOW_COMPLETE_MESSAGE = 'flow/player/SHOW_COMPLETE_MESSAGE';
var SET_PREVIEW_LIST = 'flow/player/SET_PREVIEW_LIST';
var REGISTER_ACTION = 'flow/player/REGISTER_ACTION';
var SET_PLAYING_PARENT_ID = 'flow/player/SET_PLAYING_PARENT_ID';
var SET_PARAMETERS = 'flow/player/SET_PARAMETERS';
var SET_ACCOMMODATIONS = 'flow/player/SET_ACCOMMODATIONS';
var SET_FLOW_ID = 'flow/player/SET_FLOW_ID';
var SET_PAWN_ID = 'flow/player/SET_PAWN_ID';
var SET_PAWN_HASH = 'flow/player/SET_PAWN_HASH';
var SET_RESPONSE_SET = 'flow/player/SET_RESPONSE_SET';
var SET_STARTED_PROGRESS = 'flow/player/SET_STARTED_PROGRESS';
var SET_FINISHED_PROGRESS = 'flow/player/SET_FINISHED_PROGRESS';
var SET_PAGE_STARTED_TIME = 'flow/player/SET_PAGE_STARTED_TIME';
var SET_TO_STORAGE = 'flow/player/SET_TO_STORAGE';
var ADD_SUBSCRIPTION = 'flow/player/ADD_SUBSCRIPTION';
var DELETE_SUBSCRIPTION = 'flow/player/DELETE_SUBSCRIPTION';
var SET_PLAYING_ACTION = 'flow/player/SET_PLAYING_ACTION';
var UNSET_PLAYING_ACTION = 'flow/player/UNSET_PLAYING_ACTION';
var SET_ENABLE_AUDIO = 'flow/player/SET_ENABLE_AUDIO';
var SET_IS_PRESENTER_MODE = 'flow/player/SET_IS_PRESENTER_MODE';
var SET_AUDIO_READY = 'flow/player/SET_AUDIO_READY';
var ADD_AJAX = 'flow/player/ADD_AJAX';
var REMOVE_AJAX = 'flow/player/REMOVE_AJAX';
var SHOW_BAD_CONNECTION_MESSAGE = 'flow/player/SHOW_BAD_CONNECTION_MESSAGE';
var START_FILE_PRELOAD_PROGRESS = 'flow/player/START_FILE_PRELOAD_PROGRESS';
var UPDATE_FILE_PRELOAD_PROGRESS = 'flow/player/UPDATE_FILE_PRELOAD_PROGRESS';
var COMPLETE_FILE_PRELOAD = 'flow/player/COMPLETE_FILE_PRELOAD';
var SET_PRELOADING_ASSETS_PROGRESS = 'flow/player/SET_PRELOADING_ASSETS_PROGRESS';
var SET_DYNAMIC_DATA_VALUES = 'flow/player/SET_DYNAMIC_DATA_VALUES';
var SET_DYNAMIC_USER_LISTS_VALUES = 'flow/player/SET_DYNAMIC_USER_LISTS_VALUES';
var SET_METRICS_VALUES = 'flow/player/SET_METRICS_VALUES';
var SWITCH_FEEDBACK_MODE = 'flow/player/SWITCH_FEEDBACK_MODE';

// Action Creators
var setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
exports.setLoadingState = setLoadingState;
var unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
exports.unsetLoadingState = unsetLoadingState;
var setWaitingForAjax = (0, _reduxActions.createAction)(SET_WAITING_FOR_AJAX);
exports.setWaitingForAjax = setWaitingForAjax;
var resetAll = (0, _reduxActions.createAction)(RESET_ALL);
exports.resetAll = resetAll;
var updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
exports.updateSettings = updateSettings;
var setList = (0, _reduxActions.createAction)(SET_LIST);
exports.setList = setList;
var updateAnswer = (0, _reduxActions.createAction)(UPDATE_ANSWER);
exports.updateAnswer = updateAnswer;
var updateAnswers = (0, _reduxActions.createAction)(UPDATE_ANSWERS);
exports.updateAnswers = updateAnswers;
var setAnswerError = (0, _reduxActions.createAction)(SET_ANSWER_ERROR);
exports.setAnswerError = setAnswerError;
var updateSavedAnswers = (0, _reduxActions.createAction)(UPDATE_SAVED_ANSWERS);
exports.updateSavedAnswers = updateSavedAnswers;
var updateSavedProgress = (0, _reduxActions.createAction)(UPDATE_SAVED_PROGRESS);
exports.updateSavedProgress = updateSavedProgress;
var resetAnswers = (0, _reduxActions.createAction)(RESET_ANSWERS);
exports.resetAnswers = resetAnswers;
var updatePageFirstElement = (0, _reduxActions.createAction)(UPDATE_PAGE_FIRST_ELEMENT);
exports.updatePageFirstElement = updatePageFirstElement;
var setValidationErrors = (0, _reduxActions.createAction)(SET_VALIDATION_ERRORS);
exports.setValidationErrors = setValidationErrors;
var goToNextPage = (0, _reduxActions.createAction)(GO_TO_NEXT_PAGE);
exports.goToNextPage = goToNextPage;
var goToPrevPage = (0, _reduxActions.createAction)(GO_TO_PREV_PAGE);
exports.goToPrevPage = goToPrevPage;
var resetActions = (0, _reduxActions.createAction)(RESET_ACTIONS);
exports.resetActions = resetActions;
var completeFlow = (0, _reduxActions.createAction)(COMPLETE_FLOW);
exports.completeFlow = completeFlow;
var _showCompleteMessage = (0, _reduxActions.createAction)(SHOW_COMPLETE_MESSAGE);
exports.showCompleteMessage = _showCompleteMessage;
var setPreviewList = (0, _reduxActions.createAction)(SET_PREVIEW_LIST);
exports.setPreviewList = setPreviewList;
var registerAction = (0, _reduxActions.createAction)(REGISTER_ACTION);
exports.registerAction = registerAction;
var setPlayingParentId = (0, _reduxActions.createAction)(SET_PLAYING_PARENT_ID);
exports.setPlayingParentId = setPlayingParentId;
var setParameters = (0, _reduxActions.createAction)(SET_PARAMETERS);
exports.setParameters = setParameters;
var setAccommodations = (0, _reduxActions.createAction)(SET_ACCOMMODATIONS);
exports.setAccommodations = setAccommodations;
var setFlowId = (0, _reduxActions.createAction)(SET_FLOW_ID);
exports.setFlowId = setFlowId;
var setPawnId = (0, _reduxActions.createAction)(SET_PAWN_ID);
exports.setPawnId = setPawnId;
var setPawnHash = (0, _reduxActions.createAction)(SET_PAWN_HASH);
exports.setPawnHash = setPawnHash;
var setResponseSet = (0, _reduxActions.createAction)(SET_RESPONSE_SET);
exports.setResponseSet = setResponseSet;
var setStartedProgress = (0, _reduxActions.createAction)(SET_STARTED_PROGRESS);
exports.setStartedProgress = setStartedProgress;
var setFinishedProgress = (0, _reduxActions.createAction)(SET_FINISHED_PROGRESS);
exports.setFinishedProgress = setFinishedProgress;
var setPageStartedTime = (0, _reduxActions.createAction)(SET_PAGE_STARTED_TIME);
exports.setPageStartedTime = setPageStartedTime;
var setToStorage = (0, _reduxActions.createAction)(SET_TO_STORAGE);
exports.setToStorage = setToStorage;
var addSubscription = (0, _reduxActions.createAction)(ADD_SUBSCRIPTION);
exports.addSubscription = addSubscription;
var deleteSubscription = (0, _reduxActions.createAction)(DELETE_SUBSCRIPTION);
exports.deleteSubscription = deleteSubscription;
var setPlayingAction = (0, _reduxActions.createAction)(SET_PLAYING_ACTION);
exports.setPlayingAction = setPlayingAction;
var unsetPlayingAction = (0, _reduxActions.createAction)(UNSET_PLAYING_ACTION);
exports.unsetPlayingAction = unsetPlayingAction;
var setEnableAudio = (0, _reduxActions.createAction)(SET_ENABLE_AUDIO);
exports.setEnableAudio = setEnableAudio;
var setIsPresenterMode = (0, _reduxActions.createAction)(SET_IS_PRESENTER_MODE);
exports.setIsPresenterMode = setIsPresenterMode;
var setAudioReady = (0, _reduxActions.createAction)(SET_AUDIO_READY);
exports.setAudioReady = setAudioReady;
var addAjax = (0, _reduxActions.createAction)(ADD_AJAX);
exports.addAjax = addAjax;
var removeAjax = (0, _reduxActions.createAction)(REMOVE_AJAX);
exports.removeAjax = removeAjax;
var showBadConnectionMessage = (0, _reduxActions.createAction)(SHOW_BAD_CONNECTION_MESSAGE);
exports.showBadConnectionMessage = showBadConnectionMessage;
var startFilePreloadProgress = (0, _reduxActions.createAction)(START_FILE_PRELOAD_PROGRESS);
exports.startFilePreloadProgress = startFilePreloadProgress;
var updateFilePreloadProgress = (0, _reduxActions.createAction)(UPDATE_FILE_PRELOAD_PROGRESS);
exports.updateFilePreloadProgress = updateFilePreloadProgress;
var completeFilePreload = (0, _reduxActions.createAction)(COMPLETE_FILE_PRELOAD);
exports.completeFilePreload = completeFilePreload;
var setPreloadingAssetsProgress = (0, _reduxActions.createAction)(SET_PRELOADING_ASSETS_PROGRESS);
exports.setPreloadingAssetsProgress = setPreloadingAssetsProgress;
var setDynamicDataValues = (0, _reduxActions.createAction)(SET_DYNAMIC_DATA_VALUES);
exports.setDynamicDataValues = setDynamicDataValues;
var setDynamicUserListsValues = (0, _reduxActions.createAction)(SET_DYNAMIC_USER_LISTS_VALUES);
exports.setDynamicUserListsValues = setDynamicUserListsValues;
var setMetricsValues = (0, _reduxActions.createAction)(SET_METRICS_VALUES);
exports.setMetricsValues = setMetricsValues;
var switchFeedbackMode = (0, _reduxActions.createAction)(SWITCH_FEEDBACK_MODE);
exports.switchFeedbackMode = switchFeedbackMode;
var preloadAndGoToNextPage = function preloadAndGoToNextPage() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var state, assetsToPreload, progress;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState().flow.player; // Preload assets if they haven't been preloaded yet
            assetsToPreload = (0, _player.getNextPageAssetsToPreload)(state);
            if (assetsToPreload.length > 0) {
              dispatch(startFilePreloadProgress(assetsToPreload));
              (0, _cccisdPreload["default"])({
                timeout: 120 * 1000,
                preferXHR: false,
                assets: assetsToPreload,
                onFileProgressUpdate: function onFileProgressUpdate(_ref2) {
                  var url = _ref2.url,
                    progress = _ref2.progress;
                  dispatch(updateFilePreloadProgress({
                    url: url,
                    progress: progress
                  }));
                },
                onFileLoad: function onFileLoad(_ref3) {
                  var url = _ref3.url;
                  dispatch(completeFilePreload(url));
                },
                onFileError: function onFileError(_ref4) {
                  var url = _ref4.url;
                  dispatch(completeFilePreload(url));
                }
              });
            }
            progress = (0, _player.getNextPagePreloadedAssetsProgress)(state);
            if (!(progress < 100)) {
              _context.next = 8;
              break;
            }
            dispatch(setPreloadingAssetsProgress(progress));
            _context.next = 8;
            return new Promise(function (resolve) {
              var interval = setInterval(function () {
                var updatedState = getState().flow.player;
                var updatedProgress = (0, _player.getNextPagePreloadedAssetsProgress)(updatedState);
                if (updatedProgress >= 100) {
                  clearInterval(interval);

                  // Just to show the animation that the progress comes to the end
                  dispatch(setPreloadingAssetsProgress(99));
                  setTimeout(function () {
                    dispatch(setPreloadingAssetsProgress(100));
                    resolve();
                  }, 1000);
                } else {
                  dispatch(setPreloadingAssetsProgress(updatedProgress));
                }
              }, 500);
            });
          case 8:
            dispatch(goToNextPage());
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
exports.preloadAndGoToNextPage = preloadAndGoToNextPage;
var loadFlow = function loadFlow(_ref5) {
  var flowId = _ref5.flowId,
    _ref5$pawnId = _ref5.pawnId,
    pawnId = _ref5$pawnId === void 0 ? 0 : _ref5$pawnId,
    _ref5$pawnHash = _ref5.pawnHash,
    pawnHash = _ref5$pawnHash === void 0 ? '' : _ref5$pawnHash,
    _ref5$responseSet = _ref5.responseSet,
    responseSet = _ref5$responseSet === void 0 ? 0 : _ref5$responseSet,
    _ref5$withProgress = _ref5.withProgress,
    withProgress = _ref5$withProgress === void 0 ? true : _ref5$withProgress,
    playingParentId = _ref5.playingParentId,
    _ref5$variables = _ref5.variables,
    variables = _ref5$variables === void 0 ? {} : _ref5$variables,
    _ref5$userLists = _ref5.userLists,
    userLists = _ref5$userLists === void 0 ? {} : _ref5$userLists,
    enableAudio = _ref5.enableAudio,
    pageFirstElementId = _ref5.pageFirstElementId,
    _ref5$isPreviewMode = _ref5.isPreviewMode,
    isPreviewMode = _ref5$isPreviewMode === void 0 ? false : _ref5$isPreviewMode,
    _ref5$isPresenterMode = _ref5.isPresenterMode,
    isPresenterMode = _ref5$isPresenterMode === void 0 ? false : _ref5$isPresenterMode;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var res, attributes, rootId, flowUpdatedAt, settings, stateUpdatedAt, treeUpdatedAt, dataConnectorsVariableIds, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(resetAll());
            dispatch(setLoadingState());
            dispatch(setFlowId(flowId));
            dispatch(setPawnId(pawnId));
            dispatch(setPawnHash(pawnHash));
            dispatch(setResponseSet(responseSet));
            dispatch(setDynamicDataValues(variables));
            dispatch(setDynamicUserListsValues(userLists));
            dispatch(setIsPresenterMode(isPresenterMode));
            if (typeof enableAudio !== 'undefined') {
              dispatch(setEnableAudio(enableAudio));
            }
            _context2.next = 12;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.show', {
              flow: flowId
            }));
          case 12:
            res = _context2.sent;
            attributes = res.data.data.attributes;
            rootId = attributes.root_id;
            flowUpdatedAt = attributes.updated_at;
            settings = _objectSpread(_objectSpread(_objectSpread({}, _builder.initialSettings), attributes.settings), {}, {
              name: attributes.name,
              type: attributes.type,
              language: attributes.language,
              rootId: rootId
            });
            dispatch(updateSettings(settings));

            // The way to get accommodation from app
            // const result1 = axios.get(Boilerplate.route('flow.accommodations', { flow: flowId }));
            if (!(pawnId !== 0 && responseSet !== 0)) {
              _context2.next = 24;
              break;
            }
            _context2.next = 21;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content.pawn.index', {
              flow_id: flowId,
              pawn_id: pawnId,
              index: responseSet
            }));
          case 21:
            res = _context2.sent;
            _context2.next = 33;
            break;
          case 24:
            if (!(pawnId !== 0)) {
              _context2.next = 30;
              break;
            }
            _context2.next = 27;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content.pawn', {
              flow_id: flowId,
              pawn_id: pawnId
            }));
          case 27:
            res = _context2.sent;
            _context2.next = 33;
            break;
          case 30:
            _context2.next = 32;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.player.entity.outline.content', {
              flow_id: flowId
            }));
          case 32:
            res = _context2.sent;
          case 33:
            stateUpdatedAt = (0, _get2["default"])(res, 'data.data.tree.state.updated_at', '0');
            treeUpdatedAt = (0, _get2["default"])(res, 'data.data.tree_updated_at', '0');
            dispatch(setList({
              pageFirstElementId: pageFirstElementId,
              tree: res.data.data.tree,
              elementTypes: _allElements["default"],
              withProgress: withProgress,
              startFromBeginning: flowUpdatedAt > stateUpdatedAt || treeUpdatedAt > stateUpdatedAt
            }));
            if (playingParentId) {
              dispatch(setPlayingParentId(playingParentId));
            }
            dispatch(setStartedProgress());

            // get metrics values
            dataConnectorsVariableIds = (0, _player.getDataConnectorsVariableIds)(getState().flow.player);
            if (!(dataConnectorsVariableIds.length > 0)) {
              _context2.next = 44;
              break;
            }
            _context2.next = 42;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              sourceId: flowId,
              sourceType: 'flow',
              values: '{}',
              variableIds: dataConnectorsVariableIds
            }, pawnId !== 0 && {
              pawnId: pawnId
            }), pawnId !== 0 && responseSet !== 0 && {
              responseSet: responseSet
            }), pawnId !== 0 && pawnHash !== '' && {
              pawnHash: pawnHash
            }), {}, {
              isPreviewMode: isPreviewMode
            }));
          case 42:
            response = _context2.sent;
            dispatch(setMetricsValues(response.data.data.variableValues));
          case 44:
            dispatch(unsetLoadingState());
          case 45:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};
exports.loadFlow = loadFlow;
function runAjax(_x5) {
  return _runAjax.apply(this, arguments);
}
function _runAjax() {
  _runAjax = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref7) {
    var run, dispatch, pageFirstElementId, id, result;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          run = _ref7.run, dispatch = _ref7.dispatch, pageFirstElementId = _ref7.pageFirstElementId;
          id = ajaxCount++;
          dispatch(addAjax({
            id: id,
            pageFirstElementId: pageFirstElementId
          }));
          _context13.prev = 3;
          _context13.next = 6;
          return run();
        case 6:
          result = _context13.sent;
          if (!(result !== noNetworkRequst && (result.status < 200 || result.status >= 300 || (0, _get2["default"])(result, 'data.status') !== 'success'))) {
            _context13.next = 11;
            break;
          }
          console.error('This is the result of wrong request:', JSON.stringify(result));
          (0, _browser.captureException)(new Error('Got wrong response when saving metrics or state'));
          throw new Error('There is no success response');
        case 11:
          dispatch(removeAjax(id));
          return _context13.abrupt("return", result);
        case 15:
          _context13.prev = 15;
          _context13.t0 = _context13["catch"](3);
          dispatch(showBadConnectionMessage(_context13.t0.response));
          return _context13.abrupt("return", Promise.reject(_context13.t0));
        case 19:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[3, 15]]);
  }));
  return _runAjax.apply(this, arguments);
}
var waitForResultSaved = function waitForResultSaved(dispatch, getState) {
  return new Promise(function (resolve) {
    var intervalId = setInterval(check, 200);
    check();
    function check() {
      var playerState = getState().flow.player;
      if ((0, _player.getHasUnfinishedAjax)(playerState)) {
        if (!playerState.waitingForAjax) {
          dispatch(setWaitingForAjax(true));
        }
      } else {
        clearInterval(intervalId);
        if (playerState.waitingForAjax) {
          dispatch(setWaitingForAjax(false));
        }
        resolve();
      }
    }
  });
};

// Just to not duplicate code
exports.waitForResultSaved = waitForResultSaved;
function getMetricsData(_ref8) {
  var answers = _ref8.answers,
    savedAnswers = _ref8.savedAnswers,
    list = _ref8.list,
    pageStartedTime = _ref8.pageStartedTime,
    flowId = _ref8.flowId,
    pawnId = _ref8.pawnId,
    pawnHash = _ref8.pawnHash,
    responseSet = _ref8.responseSet,
    pageElements = _ref8.pageElements,
    dynamicDataValues = _ref8.dynamicDataValues,
    settings = _ref8.settings,
    dataConnectorsVariableIds = _ref8.dataConnectorsVariableIds,
    includeOnlyDurationMetrics = _ref8.includeOnlyDurationMetrics;
  var metrics = {};
  var pawnValues = [];
  if (!includeOnlyDurationMetrics) {
    var getMetricsForElement = function getMetricsForElement(element) {
      var elementType = (0, _find2["default"])(_allElements["default"], {
        code: element.type
      });
      if (elementType && (0, _isFunction2["default"])(elementType.getMetrics)) {
        var elementMetrics = elementType.getMetrics(element.id, element.settings, answers[element.id]);
        (0, _forEach2["default"])(elementMetrics, function (value, name) {
          if ((0, _isObject2["default"])(value) && value.pawns) {
            value.pawns.forEach(function (pawnInfo) {
              var currentPawnValue = pawnValues.find(function (item) {
                return item.pawnId === pawnInfo.pawnId;
              });
              if (!currentPawnValue) {
                currentPawnValue = {
                  pawnId: pawnInfo.pawnId,
                  pawnHash: pawnInfo.pawnHash,
                  responseSet: responseSet,
                  values: {}
                };
                pawnValues.push(currentPawnValue);
              }
              currentPawnValue.values[name] = pawnInfo.value;
            });
          } else {
            metrics[name] = value;
          }
        });
      }
    };

    // Get updated answers
    (0, _forEach2["default"])(pageElements, function (element, key) {
      getMetricsForElement(element);
    });
    (0, _forEach2["default"])(answers, function (answer, key) {
      if (savedAnswers[key] && savedAnswers[key] === answer) {
        return;
      }
      getMetricsForElement(list[key]);
    });

    // Save app variables
    (settings.metricsVariables || []).forEach(function (name) {
      metrics["".concat(flowId, "_app_variable_").concat(name)] = dynamicDataValues[name] || null;
    });
  }

  // Get duration
  var duration = pageStartedTime != null ? (0, _helpers.getCurrentGmtTime)() - pageStartedTime : null;
  (0, _forEach2["default"])(pageElements, function (element) {
    metrics["".concat(element.id, "_duration")] = duration;
  });
  if (Object.keys(metrics).length === 0) {
    return null;
  }
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    sourceId: flowId,
    sourceType: 'flow',
    duration: duration,
    values: JSON.stringify(metrics)
  }, pawnValues.length > 0 && {
    pawnValues: pawnValues.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        values: JSON.stringify(item.values)
      });
    })
  }), {}, {
    variableIds: dataConnectorsVariableIds
  }, pawnId !== 0 && {
    pawnId: pawnId
  }), pawnId !== 0 && responseSet !== 0 && {
    responseSet: responseSet
  }), pawnId !== 0 && pawnHash !== '' && {
    pawnHash: pawnHash
  });
}

// Just to not duplicate code
function getProgressData(playerState) {
  var progress = playerState.progress,
    savedProgress = playerState.savedProgress,
    answers = playerState.answers,
    savedAnswers = playerState.savedAnswers,
    rootId = playerState.rootId,
    pageFirstElementId = playerState.pageFirstElementId,
    storage = playerState.storage,
    pageHistory = playerState.pageHistory;
  var updatedProgress = [];
  (0, _forEach2["default"])(answers, function (answer, key) {
    if (!savedAnswers[key] || savedAnswers[key] !== answer) {
      updatedProgress.push(_objectSpread({
        key: key,
        value: answer
      }, progress[key] && {
        progress: progress[key]
      }));
    }
  });
  (0, _forEach2["default"])(progress, function (obj, key) {
    if (!savedProgress[key] || !(0, _isEqual2["default"])(savedProgress[key], obj)) {
      if (!updatedProgress.find(function (item) {
        return item.key === key;
      })) {
        updatedProgress.push(_objectSpread({
          key: key,
          progress: obj
        }, answers[key] && {
          value: answers[key]
        }));
      }
    }
  });
  if (rootId !== 0) {
    updatedProgress.push({
      key: rootId.toString(),
      lastUnfinishedElement: pageFirstElementId,
      storage: storage,
      pageHistory: pageHistory
    });
  }
  if (updatedProgress.length === 0) {
    return null;
  }
  var data = {
    response_set: _objectSpread({}, (0, _player.getFlowStartedFinished)(playerState)),
    entity_states: updatedProgress.map(function (item) {
      var itemProgress = item.progress || {};
      var attributes = {
        // started_first: null,
        // finished_first: null,
        // started_last: '2017-03-19 13:09:33',
        // finished_last: '2017-03-19 13:09:33',
        entity_id: item.key,
        state: JSON.stringify((0, _omit2["default"])(item, ['key', 'progress']))
      };
      if (itemProgress.startedFirst) {
        attributes.started_first = itemProgress.startedFirst;
      }
      if (itemProgress.startedLast) {
        attributes.started_last = itemProgress.startedLast;
      }
      if (itemProgress.finishedFirst) {
        attributes.finished_first = itemProgress.finishedFirst;
      }
      if (itemProgress.finishedLast) {
        attributes.finished_last = itemProgress.finishedLast;
      }
      return {
        attributes: attributes
      };
    })
  };
  return data;
}

// Saves metrics and progress at the same time
var saveResult = function saveResult() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$loading = _ref9.loading,
    loading = _ref9$loading === void 0 ? false : _ref9$loading,
    _ref9$playerState = _ref9.playerState,
    playerState = _ref9$playerState === void 0 ? (0, _helpers.required)('playerState') : _ref9$playerState,
    pageElements = _ref9.pageElements,
    _ref9$includeMetrics = _ref9.includeMetrics,
    includeMetrics = _ref9$includeMetrics === void 0 ? true : _ref9$includeMetrics,
    _ref9$includeProgress = _ref9.includeProgress,
    includeProgress = _ref9$includeProgress === void 0 ? true : _ref9$includeProgress,
    _ref9$includeOnlyDura = _ref9.includeOnlyDurationMetrics,
    includeOnlyDurationMetrics = _ref9$includeOnlyDura === void 0 ? false : _ref9$includeOnlyDura;
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch, getState) {
      var flowId, pawnId, responseSet, pageFirstElementId, isPresenterMode, saveMetrics, _saveMetrics, saveProgress, _saveProgress;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _saveProgress = function _saveProgress3() {
              _saveProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                var data;
                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      data = getProgressData(playerState);
                      if (data) {
                        _context5.next = 3;
                        break;
                      }
                      return _context5.abrupt("return");
                    case 3:
                      dispatch(updateSavedProgress());
                      if (!(responseSet !== 0 && pawnId !== 0)) {
                        _context5.next = 11;
                        break;
                      }
                      data.response_set.pawn_id = pawnId;
                      data.response_set.index = responseSet;
                      _context5.next = 9;
                      return runAjax({
                        run: function run() {
                          return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findByAttr.entity.batch.store', {
                            flow_id: flowId
                          }), data);
                        },
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 9:
                      _context5.next = 14;
                      break;
                    case 11:
                      if (pawnId !== 0) {
                        data.response_set.pawn_id = pawnId;
                      }
                      _context5.next = 14;
                      return runAjax({
                        run: function run() {
                          return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findById.entity.batch.store', {
                            flow_id: flowId,
                            response_set: 'latest'
                          }), data);
                        },
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 14:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
              return _saveProgress.apply(this, arguments);
            };
            saveProgress = function _saveProgress2() {
              return _saveProgress.apply(this, arguments);
            };
            _saveMetrics = function _saveMetrics3() {
              _saveMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                var dataConnectorsVariableIds, data;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      dataConnectorsVariableIds = (0, _player.getDataConnectorsVariableIds)(playerState);
                      if (includeOnlyDurationMetrics) {
                        data = getMetricsData(_objectSpread(_objectSpread({}, playerState), {}, {
                          pageElements: pageElements,
                          dataConnectorsVariableIds: dataConnectorsVariableIds,
                          includeOnlyDurationMetrics: true
                        }));
                      } else {
                        data = getMetricsData(_objectSpread(_objectSpread({}, playerState), {}, {
                          pageElements: pageElements,
                          dataConnectorsVariableIds: dataConnectorsVariableIds
                        }));
                        dispatch(updateSavedAnswers());
                      }
                      if (!data) {
                        _context4.next = 5;
                        break;
                      }
                      _context4.next = 5;
                      return runAjax({
                        run: function () {
                          var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                            var response;
                            return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                              while (1) switch (_context3.prev = _context3.next) {
                                case 0:
                                  _context3.next = 2;
                                  return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.data.bulkUpdate'), data);
                                case 2:
                                  response = _context3.sent;
                                  dispatch(setMetricsValues(response.data.data.variableValues));
                                  return _context3.abrupt("return", response);
                                case 5:
                                case "end":
                                  return _context3.stop();
                              }
                            }, _callee3);
                          }));
                          function run() {
                            return _run.apply(this, arguments);
                          }
                          return run;
                        }(),
                        dispatch: dispatch,
                        pageFirstElementId: pageFirstElementId
                      });
                    case 5:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return _saveMetrics.apply(this, arguments);
            };
            saveMetrics = function _saveMetrics2() {
              return _saveMetrics.apply(this, arguments);
            };
            loading && dispatch(setLoadingState());
            flowId = playerState.flowId, pawnId = playerState.pawnId, responseSet = playerState.responseSet, pageFirstElementId = playerState.pageFirstElementId, isPresenterMode = playerState.isPresenterMode;
            pageElements = pageElements || (0, _player.getPageElements)(playerState);
            if (isPresenterMode) {
              _context6.next = 14;
              break;
            }
            if (!includeMetrics) {
              _context6.next = 11;
              break;
            }
            _context6.next = 11;
            return saveMetrics();
          case 11:
            if (!includeProgress) {
              _context6.next = 14;
              break;
            }
            _context6.next = 14;
            return saveProgress();
          case 14:
            loading && dispatch(unsetLoadingState());
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function (_x6, _x7) {
      return _ref10.apply(this, arguments);
    };
  }();
};
exports.saveResult = saveResult;
var saveMetricsOnUnload = function saveMetricsOnUnload() {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var playerState, flowId, pawnId, responseSet, hasBadConnection, waitingForAjax, saveProgress, currState;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            saveProgress = function _saveProgress4() {
              var progressData = getProgressData(playerState);
              if (!progressData) {
                return noNetworkRequst;
              }
              var data = _objectSpread(_objectSpread({}, progressData), {}, {
                _token: Boilerplate.settings.csrfToken
              });
              if (responseSet !== 0 && pawnId !== 0) {
                data.response_set.pawn_id = pawnId;
                data.response_set.index = responseSet;
                return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findByAttr.entity.batch.store', {
                  flow_id: flowId
                }), data, {
                  timeout: 15 * 1000
                });
              }
              if (pawnId !== 0) {
                data.response_set.pawn_id = pawnId;
              }
              return _cccisdAxios["default"].post(Boilerplate.route('flow.response_set.findById.entity.batch.store', {
                flow_id: flowId,
                response_set: 'latest'
              }), data, {
                timeout: 15 * 1000
              });
            };
            // We'll just save progress here. Saving metrics are not necessary anymore
            playerState = getState().flow.player;
            flowId = playerState.flowId, pawnId = playerState.pawnId, responseSet = playerState.responseSet, hasBadConnection = playerState.hasBadConnection, waitingForAjax = playerState.waitingForAjax; // Don't save it if there were some bad connections
            if (!(hasBadConnection || waitingForAjax)) {
              _context7.next = 5;
              break;
            }
            return _context7.abrupt("return");
          case 5:
            currState = getState();
            _context7.next = 8;
            return runAjax({
              run: function run() {
                return saveProgress();
              },
              dispatch: dispatch,
              pageFirstElementId: currState.flow.player.pageFirstElementId
            });
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x8, _x9) {
      return _ref11.apply(this, arguments);
    };
  }();
};
exports.saveMetricsOnUnload = saveMetricsOnUnload;
var saveAndGoToNextPage = function saveAndGoToNextPage(_ref12) {
  var isPreviewMode = _ref12.isPreviewMode,
    onComplete = _ref12.onComplete;
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var playerState, _playerState, isPresenterMode, pageElements, _saveResult, hasPageFeedback, isFeedbackMode, waitForMetricsSaved;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            playerState = getState().flow.player;
            _playerState = playerState, isPresenterMode = _playerState.isPresenterMode;
            pageElements = (0, _player.getPageElements)(playerState);
            _saveResult = function _saveResult(args) {
              if (!isPreviewMode) {
                return dispatch(saveResult(_objectSpread(_objectSpread({}, args), {}, {
                  playerState: playerState
                })));
              }
            };
            hasPageFeedback = (0, _player.getHasPageFeedback)(playerState);
            isFeedbackMode = playerState.isFeedbackMode;
            _context8.next = 8;
            return waitForResultSaved(dispatch, getState);
          case 8:
            // Update player state. It could change from last time
            playerState = getState().flow.player;

            // Reset actions
            dispatch(resetActions());
            if (!((0, _player.isErrorOnThePage)(playerState) && !isPresenterMode)) {
              _context8.next = 14;
              break;
            }
            dispatch(setValidationErrors());
            _context8.next = 43;
            break;
          case 14:
            if (!(hasPageFeedback && !isFeedbackMode)) {
              _context8.next = 18;
              break;
            }
            // Show feedback
            dispatch(switchFeedbackMode(true));
            _context8.next = 43;
            break;
          case 18:
            if ((0, _player.isLastPage)(playerState)) {
              _context8.next = 37;
              break;
            }
            dispatch(setFinishedProgress());

            // Update player state
            playerState = getState().flow.player;
            waitForMetricsSaved = (0, _player.getWaitForMetricsSaved)(playerState);
            if (!waitForMetricsSaved) {
              _context8.next = 31;
              break;
            }
            _saveResult();
            _context8.next = 26;
            return waitForResultSaved(dispatch, getState);
          case 26:
            _context8.next = 28;
            return dispatch(preloadAndGoToNextPage());
          case 28:
            dispatch(setStartedProgress());
            _context8.next = 35;
            break;
          case 31:
            _context8.next = 33;
            return dispatch(preloadAndGoToNextPage());
          case 33:
            dispatch(setStartedProgress());
            _saveResult({
              pageElements: pageElements
            });
          case 35:
            _context8.next = 43;
            break;
          case 37:
            // Complete the flow
            dispatch(setFinishedProgress());
            dispatch(completeFlow());
            _saveResult();

            // wait for result saved before calling onComplete()
            _context8.next = 42;
            return waitForResultSaved(dispatch, getState);
          case 42:
            if (onComplete) {
              onComplete({
                showCompleteMessage: function showCompleteMessage() {
                  return dispatch(_showCompleteMessage());
                }
              });
            } else {
              dispatch(_showCompleteMessage());
            }
          case 43:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x10, _x11) {
      return _ref13.apply(this, arguments);
    };
  }();
};
exports.saveAndGoToNextPage = saveAndGoToNextPage;
var saveAndGoToPrevPage = function saveAndGoToPrevPage() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isPreviewMode = _ref14.isPreviewMode;
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch, getState) {
      var playerState;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            playerState = getState().flow.player;
            _context9.next = 3;
            return waitForResultSaved(dispatch, getState);
          case 3:
            if (!isPreviewMode) {
              dispatch(saveResult({
                includeOnlyDurationMetrics: true,
                playerState: playerState
              }));
            }
            dispatch(goToPrevPage());
          case 5:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x12, _x13) {
      return _ref15.apply(this, arguments);
    };
  }();
};
exports.saveAndGoToPrevPage = saveAndGoToPrevPage;
var saveAndGoToComponent = function saveAndGoToComponent(_ref16) {
  var componentId = _ref16.componentId,
    isPreviewMode = _ref16.isPreviewMode;
  return /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch, getState) {
      var playerState;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            playerState = getState().flow.player;
            _context10.next = 3;
            return waitForResultSaved(dispatch, getState);
          case 3:
            dispatch(setFinishedProgress());
            dispatch(updatePageFirstElement(componentId));
            dispatch(setStartedProgress());
            if (!isPreviewMode) {
              dispatch(saveResult({
                includeOnlyDurationMetrics: true,
                playerState: playerState
              }));
            }
          case 7:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x14, _x15) {
      return _ref17.apply(this, arguments);
    };
  }();
};
exports.saveAndGoToComponent = saveAndGoToComponent;
var saveStateAndMetrics = function saveStateAndMetrics() {
  var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isPreviewMode = _ref18.isPreviewMode,
    completeFlowIfLastPage = _ref18.completeFlowIfLastPage;
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch, getState) {
      var playerState, pageElements;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (!isPreviewMode) {
              _context11.next = 2;
              break;
            }
            return _context11.abrupt("return");
          case 2:
            playerState = getState().flow.player;
            pageElements = (0, _player.getPageElements)(playerState);
            _context11.next = 6;
            return waitForResultSaved(dispatch, getState);
          case 6:
            // Update player state. It could change from last time
            playerState = getState().flow.player;
            if (!(completeFlowIfLastPage && (0, _player.isLastPage)(playerState))) {
              _context11.next = 16;
              break;
            }
            // Complete the flow
            dispatch(setFinishedProgress());
            dispatch(completeFlow());
            _context11.next = 12;
            return dispatch(saveResult({
              playerState: playerState
            }));
          case 12:
            _context11.next = 14;
            return waitForResultSaved(dispatch, getState);
          case 14:
            _context11.next = 18;
            break;
          case 16:
            _context11.next = 18;
            return dispatch(saveResult({
              pageElements: pageElements,
              playerState: playerState
            }));
          case 18:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x16, _x17) {
      return _ref19.apply(this, arguments);
    };
  }();
};

// Blocks could filter or randomize children
exports.saveStateAndMetrics = saveStateAndMetrics;
var defineChildren = function defineChildren() {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch, getState) {
      var playerState, answers;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            playerState = getState().flow.player;
            answers = [];
            Object.values(playerState.list).forEach(function (element) {
              var elementType = allElementsObject[element.type];
              if (!element.children || !elementType || !elementType.selectChildren) {
                return;
              }
              var selectedChildren = (0, _get2["default"])(playerState.answers, "".concat(element.id, ".selectedChildren"));
              var hasSelectedChildren = Boolean(selectedChildren);
              var needSelection = false;
              if (!Array.isArray(selectedChildren)) {
                needSelection = true;
              } else {
                // all selected children should still exist, otherwise we'll reselect
                needSelection = (0, _difference2["default"])(selectedChildren, element.children).length > 0;
              }
              if (needSelection) {
                selectedChildren = elementType.selectChildren(element.children, element.settings);
                if (Array.isArray(selectedChildren)) {
                  answers.push({
                    elementId: element.id,
                    answer: _objectSpread(_objectSpread({}, playerState.answers[element.id]), {}, {
                      selectedChildren: selectedChildren
                    })
                  });
                } else if (hasSelectedChildren) {
                  answers.push({
                    elementId: element.id,
                    answer: (0, _omit2["default"])(playerState.answers[element.id] || {}, ['selectedChildren'])
                  });
                }
              }
            });
            dispatch(updateAnswers(answers));
          case 4:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x18, _x19) {
      return _ref20.apply(this, arguments);
    };
  }();
};

// Reducer
exports.defineChildren = defineChildren;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), _defineProperty(_handleActions, UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), _defineProperty(_handleActions, SET_WAITING_FOR_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    waitingForAjax: action.payload
  });
}), _defineProperty(_handleActions, RESET_ALL, function (state, action) {
  return _objectSpread(_objectSpread({}, initialState), {}, {
    isAudioReady: state.isAudioReady,
    enableAudio: state.enableAudio
  });
}), _defineProperty(_handleActions, UPDATE_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: action.payload
  });
}), _defineProperty(_handleActions, SET_LIST, function (state, action) {
  var _action$payload = action.payload,
    tree = _action$payload.tree,
    elementTypes = _action$payload.elementTypes,
    withProgress = _action$payload.withProgress,
    startFromBeginning = _action$payload.startFromBeginning,
    pageFirstElementId = _action$payload.pageFirstElementId;
  var result = {};
  var answers = {};
  var progress = {};
  var rootId = +tree.id;
  var storage = {};
  var pageHistory = [];
  if (withProgress && tree.state && tree.state.state) {
    if (typeof pageFirstElementId !== 'number') {
      pageFirstElementId = startFromBeginning ? 0 : +tree.state.state.lastUnfinishedElement || 0;
    }
    storage = tree.state.state.storage || {};
    pageHistory = (tree.state.state.pageHistory || []).map(function (id) {
      return +id;
    });
  }
  if (typeof pageFirstElementId !== 'number') {
    pageFirstElementId = 0;
  }
  function getChildren(subtree) {
    subtree.forEach(function (item) {
      var elementType = (0, _find2["default"])(elementTypes, {
        code: item.type
      });
      if (!elementType) {
        throw new Error("Unknown type \"".concat(item.type, "\""));
      }
      var settings = item.content[0];
      if (withProgress && item.state) {
        if (item.state.state && item.state.state.value !== undefined) {
          answers[item.id] = item.state.state.value;
        }
        var itemProgress = {};
        if (item.state.started_first) {
          itemProgress.startedFirst = item.state.started_first;
        }
        if (item.state.started_last) {
          itemProgress.startedLast = item.state.started_last;
        }
        if (item.state.finished_first) {
          itemProgress.finishedFirst = item.state.finished_first;
        }
        if (item.state.finished_last) {
          itemProgress.finishedLast = item.state.finished_last;
        }
        if (!(0, _isEqual2["default"])(itemProgress, {})) {
          progress[item.id] = itemProgress;
        }
      }
      result[item.id] = _objectSpread({
        id: item.id,
        type: item.type,
        settings: settings.content
      }, (0, _pick2["default"])(elementType, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage']));
      if (elementType.isAdult) {
        result[item.id].children = [];
      }
      if (item.children && item.children.length > 0) {
        result[item.id].children = item.children.map(function (child) {
          return child.id;
        });
        getChildren(item.children);
      }
    });
  }
  result[0] = {
    id: 0,
    children: tree.children.map(function (item) {
      return item.id;
    })
  };
  getChildren(tree.children);
  return _objectSpread(_objectSpread({}, state), {}, {
    pageFirstElementId: pageFirstElementId,
    list: result,
    rootId: rootId,
    answers: answers,
    savedAnswers: answers,
    progress: progress,
    savedProgress: progress,
    storage: storage,
    pageHistory: pageHistory
  });
}), _defineProperty(_handleActions, UPDATE_ANSWER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: _objectSpread(_objectSpread({}, state.answers), {}, _defineProperty({}, action.payload.elementId, action.payload.answer)),
    errors: (0, _omit2["default"])(state.errors, action.payload.elementId)
  });
}), _defineProperty(_handleActions, UPDATE_ANSWERS, function (state, action) {
  if (action.payload.length === 0) {
    return state;
  }
  var newAnswers = _objectSpread({}, state.answers);
  var newErrors = _objectSpread({}, state.errors);
  action.payload.forEach(function (element) {
    newAnswers[element.elementId] = element.answer;
    delete newErrors[element.elementId];
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: newAnswers,
    errors: newErrors
  });
}), _defineProperty(_handleActions, RESET_ANSWERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    answers: {},
    savedAnswers: {}
  });
}), _defineProperty(_handleActions, SET_ANSWER_ERROR, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.payload.elementId, action.payload.message))
  });
}), _defineProperty(_handleActions, UPDATE_SAVED_ANSWERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedAnswers: state.answers
  });
}), _defineProperty(_handleActions, UPDATE_SAVED_PROGRESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedProgress: state.progress
  });
}), _defineProperty(_handleActions, UPDATE_PAGE_FIRST_ELEMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pageHistory: [state.pageFirstElementId].concat(_toConsumableArray(state.pageHistory || [])),
    pageFirstElementId: action.payload,
    showValidationErrors: false
  });
}), _defineProperty(_handleActions, SET_VALIDATION_ERRORS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showValidationErrors: state.showValidationErrors + 1
  });
}), _defineProperty(_handleActions, GO_TO_NEXT_PAGE, function (state, action) {
  var nextElementId = (0, _player.getNextFirstElementId)(state);
  if (!nextElementId) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    pageHistory: [state.pageFirstElementId].concat(_toConsumableArray(state.pageHistory || [])),
    pageFirstElementId: nextElementId,
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    isFeedbackMode: false
  });
}), _defineProperty(_handleActions, GO_TO_PREV_PAGE, function (state, action) {
  var pageHistory = state.pageHistory,
    list = state.list;
  var sanitizedPageHistory = (0, _dropWhile2["default"])(pageHistory, function (id) {
    return !list[id];
  });
  if (sanitizedPageHistory.length === 0) {
    return state;
  }
  var _sanitizedPageHistory = _toArray(sanitizedPageHistory),
    nextId = _sanitizedPageHistory[0],
    newPageHistory = _sanitizedPageHistory.slice(1);
  return _objectSpread(_objectSpread({}, state), {}, {
    pageFirstElementId: nextId,
    pageHistory: newPageHistory,
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    isFeedbackMode: false
  });
}), _defineProperty(_handleActions, RESET_ACTIONS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    actions: [],
    playingAction: []
  });
}), _defineProperty(_handleActions, COMPLETE_FLOW, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isCompleted: true
  });
}), _defineProperty(_handleActions, SHOW_COMPLETE_MESSAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isCompleteMessage: true
  });
}), _defineProperty(_handleActions, SET_PREVIEW_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    list: action.payload,
    answers: {},
    savedAnswers: {},
    progress: {},
    savedProgress: {},
    isCompleted: false,
    isCompleteMessage: false,
    pageFirstElementId: 0,
    pageHistory: [],
    showValidationErrors: false,
    actions: [],
    playingAction: [],
    storage: {},
    subscriptions: {},
    isFeedbackMode: false
  });
}), _defineProperty(_handleActions, REGISTER_ACTION, function (state, action) {
  if (!(0, _isFunction2["default"])(action.payload.play) || !(0, _isFunction2["default"])(action.payload.stop)) {
    console.error('Action has to return object with at least two methods: play() and stop()');
    return state;
  }
  var ids = state.actions.map(function (item) {
    return item.id;
  });
  var newId = ids.length > 0 ? (0, _max2["default"])(ids) + 1 : 1;
  return _objectSpread(_objectSpread({}, state), {}, {
    actions: [].concat(_toConsumableArray(state.actions), [_objectSpread({
      id: newId
    }, action.payload)])
  });
}), _defineProperty(_handleActions, SET_PLAYING_PARENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingParentId: action.payload
  });
}), _defineProperty(_handleActions, SET_PARAMETERS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    parameters: _objectSpread(_objectSpread({}, state.parameters), action.payload)
  });
}), _defineProperty(_handleActions, SET_ACCOMMODATIONS, function (state, action) {
  var accommodations = action.payload;
  var knownAccommodations = ['masking', 'highlighting', 'autoplayQuestions', 'autoplayChoices', 'autoplayInstructions', 'blockUserInteractions'];
  var unknownAccommodations = (0, _keys2["default"])((0, _omit2["default"])(accommodations, knownAccommodations));
  if (unknownAccommodations.length > 0) {
    throw new Error("Unknown accommodations \"".concat(unknownAccommodations.join(', '), "\""));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    accommodations: accommodations
  });
}), _defineProperty(_handleActions, SET_FLOW_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    flowId: action.payload
  });
}), _defineProperty(_handleActions, SET_PAWN_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pawnId: action.payload
  });
}), _defineProperty(_handleActions, SET_PAWN_HASH, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pawnHash: action.payload
  });
}), _defineProperty(_handleActions, SET_RESPONSE_SET, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    responseSet: action.payload
  });
}), _defineProperty(_handleActions, SET_STARTED_PROGRESS, function (state, action) {
  var startedProgress = (0, _filter2["default"])((0, _player.getProgress)(state), {
    progress: 'started'
  });
  var progress = (0, _cloneDeep2["default"])(state.progress);
  var date = (0, _helpers.getCurrentFormattedGmtTime)();
  startedProgress.forEach(function (item) {
    if (!progress[item.id]) {
      progress[item.id] = {};
    }
    if (!progress[item.id].startedFirst) {
      progress[item.id].startedFirst = date;
    }
    progress[item.id].startedLast = date;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    progress: progress
  });
}), _defineProperty(_handleActions, SET_FINISHED_PROGRESS, function (state, action) {
  var finishedProgress = (0, _filter2["default"])((0, _player.getProgress)(state), {
    progress: 'finished'
  });
  var progress = (0, _cloneDeep2["default"])(state.progress);
  var date = (0, _helpers.getCurrentFormattedGmtTime)();
  finishedProgress.forEach(function (item) {
    if (!progress[item.id]) {
      progress[item.id] = {};
    }
    if (!progress[item.id].finishedFirst) {
      progress[item.id].finishedFirst = date;
    }
    progress[item.id].finishedLast = date;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    progress: progress
  });
}), _defineProperty(_handleActions, SET_PAGE_STARTED_TIME, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    pageStartedTime: action.payload
  });
}), _defineProperty(_handleActions, SET_TO_STORAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    storage: _objectSpread(_objectSpread({}, state.storage), action.payload)
  });
}), _defineProperty(_handleActions, ADD_SUBSCRIPTION, function (state, action) {
  var _action$payload2 = action.payload,
    token = _action$payload2.token,
    event = _action$payload2.event,
    callback = _action$payload2.callback;
  return _objectSpread(_objectSpread({}, state), {}, {
    subscriptions: _objectSpread(_objectSpread({}, state.subscriptions), {}, _defineProperty({}, token, {
      event: event,
      callback: callback
    }))
  });
}), _defineProperty(_handleActions, DELETE_SUBSCRIPTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    subscriptions: (0, _omit2["default"])(state.subscriptions, action.payload)
  });
}), _defineProperty(_handleActions, SET_PLAYING_ACTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingAction: [].concat(_toConsumableArray((0, _filter2["default"])(state.playingAction, function (item) {
      return item.id !== action.payload.id;
    })), [action.payload])
  });
}), _defineProperty(_handleActions, UNSET_PLAYING_ACTION, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    playingAction: (0, _filter2["default"])(state.playingAction, function (item) {
      return item.id !== action.payload;
    })
  });
}), _defineProperty(_handleActions, SET_AUDIO_READY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isAudioReady: true
  });
}), _defineProperty(_handleActions, ADD_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    ajax: [].concat(_toConsumableArray(state.ajax), [action.payload])
  });
}), _defineProperty(_handleActions, REMOVE_AJAX, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    ajax: state.ajax.filter(function (obj) {
      return obj.id !== action.payload;
    })
  });
}), _defineProperty(_handleActions, SHOW_BAD_CONNECTION_MESSAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasBadConnection: true,
    badConnectionInfo: action.payload
  });
}), _defineProperty(_handleActions, START_FILE_PRELOAD_PROGRESS, function (state, action) {
  var preloadedUrls = state.preloadedAssets.map(function (asset) {
    return asset.url;
  });
  var newAssets = action.payload.filter(function (url) {
    return !preloadedUrls.includes(url);
  }).map(function (url) {
    return {
      url: url,
      status: 'inProgress',
      progress: 0
    };
  });
  if (newAssets.length === 0) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets), _toConsumableArray(newAssets))
  });
}), _defineProperty(_handleActions, UPDATE_FILE_PRELOAD_PROGRESS, function (state, action) {
  var _action$payload3 = action.payload,
    url = _action$payload3.url,
    progress = _action$payload3.progress;
  var asset = _objectSpread(_objectSpread({}, state.preloadedAssets.find(function (item) {
    return item.url === url;
  })), {}, {
    url: url,
    progress: progress
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets.filter(function (item) {
      return item.url !== url;
    })), [asset])
  });
}), _defineProperty(_handleActions, COMPLETE_FILE_PRELOAD, function (state, action) {
  var asset = _objectSpread(_objectSpread({}, state.preloadedAssets.find(function (item) {
    return item.url === action.payload;
  })), {}, {
    url: action.payload,
    status: 'done'
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadedAssets: [].concat(_toConsumableArray(state.preloadedAssets.filter(function (item) {
      return item.url !== action.payload;
    })), [asset])
  });
}), _defineProperty(_handleActions, SET_PRELOADING_ASSETS_PROGRESS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    preloadingAssetsProgress: action.payload
  });
}), _defineProperty(_handleActions, SET_DYNAMIC_DATA_VALUES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    dynamicDataValues: action.payload
  });
}), _defineProperty(_handleActions, SET_DYNAMIC_USER_LISTS_VALUES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    dynamicUserListsValues: action.payload
  });
}), _defineProperty(_handleActions, SET_METRICS_VALUES, function (state, action) {
  var values = action.payload;
  var variableIds = (0, _player.getDataConnectorsVariableIds)(state);
  var newValues = variableIds.reduce(function (obj, id) {
    if (values[id] || values[id] === 0) {
      obj[id] = "".concat(values[id]);
    }
    return obj;
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    metricsValues: newValues
  });
}), _defineProperty(_handleActions, SET_ENABLE_AUDIO, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    enableAudio: Boolean(action.payload)
  });
}), _defineProperty(_handleActions, SET_IS_PRESENTER_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPresenterMode: Boolean(action.payload)
  });
}), _defineProperty(_handleActions, SWITCH_FEEDBACK_MODE, function (state, action) {
  if (state.isFeedbackMode === action.payload) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    isFeedbackMode: action.payload
  });
}), _handleActions), initialState);
var _default = reducer;
exports["default"] = _default;